import React, { useState } from "react";

import { Button, Typography } from "@mui/material";
import HouseIcon from "@mui/icons-material/House";

import { useOnLogout } from "app/modules/app-auth/hook";
import { AUTOSERVICE_PAYMENT, AUTOSERVICE_SIMPLE } from "app/config/globals";

import { useTranslation } from "react-i18next";

const RedirectToHome = ({ url }) => {
  const { t } = useTranslation();

  const [userCode, setUserCode] = useState(false);

  const [sendLogout, setSendLogout] = useState(false);

  useOnLogout(userCode, sendLogout, setSendLogout);

  const handleRedirect = () => {
    /*     setSend(false);
        setMostrarRefresh(false);
        setesperaLogin(false);
        setLoggedUser(false);
        localStorage.removeItem("tipocliente");
        localStorage.removeItem("idGrupoStorage");
        localStorage.removeItem("cedula");
        localStorage.removeItem("origen"); */

    const urlAutoservice = process.env.REACT_APP_URL_AUTOSERVICE;

    if (
      localStorage.getItem("station") === AUTOSERVICE_PAYMENT ||
      localStorage.getItem("station") === AUTOSERVICE_SIMPLE
    ) {
      setSendLogout(true);
      window.opener = null;
      window.open(urlAutoservice, "_self");
      window.close();
    } else {
      window.open(url, "_self");
    }
  };

  return (
    <div>
      <Button
        size="lg"
        variant="outlined"
        startIcon={<HouseIcon />}
        onClick={() => handleRedirect()}
      >
        <Typography>{t("redirect.button")}</Typography>
      </Button>
    </div>
  );
};

export default RedirectToHome;
